import React from "react";

const LangSwitcher = () => {
  return (
    <ul>
      {[
        { code: "en", name: "English" },
        { code: "fr", name: "Français" },
        { code: "es", name: "Español" }
      ].map(({ code, name }) => {
        // eslint-disable-next-line no-undef
        return code === __LOCALE__ ? (
          <li class="active">{name}</li>
        ) : (
          <li>
            <a
              href={`/${code}/`}
              onClick={e => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
                window.location =
                  window.location.origin +
                  "/" +
                  code +
                  "/" +
                  window.location.hash;
              }}
            >
              {name}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

export default LangSwitcher;
